import { useMemo } from "react";
import { useMeetingStore } from "../store/meeting.store";

export function useSidebarItems(
  role?: string,
  delegation?: boolean,
  menuConfig?: any
) {
  const readerCauseIconShow = useMeetingStore(
    (state) => state.readerCauseIconShow
  );

  return useMemo(() => {
    if (!role) return [];

    return (menuConfig[role] || []).filter((item: any) => {
      // Reader + Cause List visibility
      if (role === "Reader" && item.id === "cause-list") {
        return readerCauseIconShow;
      }

      // Reader delegation-based rules (future-safe)
      if (role === "Reader" && delegation === false) {
        return item.id !== "reader-delegation";
      }

      return true;
    });
  }, [role, delegation, readerCauseIconShow]);
}
